import React from "react";
import Button from "../atoms/Buttons";
import "./HotSeatWinnerContent.css";
import "./HotSeatEmptyContent.css";

export default function HotSeatEmptyContent({ onRetry, onBack, description, retryLabel = "REINTENTAR" }) {
  return (
    <section className="royal-winner royal-empty" data-testid="hotseat-empty-result" aria-label="Sorteo sin ganador">
      <div className="royal-neon-corners" aria-hidden="true"><i /><i /><i /><i /></div>
      <div className="royal-empty-content">
        <p className="royal-position">SORTEO FINALIZADO</p>
        <h1 className="royal-heading">SIN GANADOR</h1>
        <p className="royal-empty-description">{description || <>Este sorteo finalizó sin una<br />posición ganadora.</>}</p>
        <div className="royal-actions">
          <Button variant="outline" onClick={onRetry}>{retryLabel}</Button>
          <Button onClick={onBack}>VOLVER A SORTEOS</Button>
        </div>
      </div>
    </section>
  );
}
